import colors from "../../../../../../config/colors"

export const GraphColors = {
    "good":colors.green,
    "bad":colors.red,
    "neutral":colors.darkPrimary+"88"
}
export const GraphSpecificProperties = {
}